<div class="all-app-content">
  <app-header />

  <div class="main-content" [ngClass]="{ 'logged-in': loggedIn() }">
    <router-outlet />
  </div>

  <div class="footer-content">
    <app-footer />
  </div>
</div>
